import React from "react";
import ReactDatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { format, isValid } from "date-fns";

import { DATE_FNS_SHORT_DATE_FORMAT, DATE_FNS_LONG_DATE_FORMAT } from "../../../shared/constants";

export class DatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: props.value ? new Date(props.value) : null,
        };
        this.datePickerRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value === this.props.value) {
            return;
        }

        const startDate = this.props.value ? new Date(this.props.value) : null;
        this.setState({ startDate });
    }

    getDateTimeFormat() {
        return this.props.showTimeSelect ? DATE_FNS_LONG_DATE_FORMAT : DATE_FNS_SHORT_DATE_FORMAT;
    }

    handleChangeRaw(date) {
        if (isValid(date)) {
            const dateValue = format(new Date(date), this.getDateTimeFormat());

            this.handleChange(dateValue);
        }
    }

    handleChange = (date) => {
        const startDate = isValid(date) ? new Date(date) : null;
        this.setState({ startDate });
        const value = date ? date : "";
        this.props.updateOnChange(
            this.props.name,
            this.props.emitAsString ? (value ? format(new Date(value), this.getDateTimeFormat()) : value) : value
        );
    };

    focusDatePicker = () => {
        this.datePickerRef.current.setFocus();
    };

    calenderIcon = () => {
        return (
            <button
                type="button"
                className="button -text -default-color"
                onClick={this.focusDatePicker}
            >
                <FontAwesomeIcon icon={faCalendarAlt} />
            </button>
        );
    };

    render() {
        const { showTimeSelect, autoFocus, isClearable, minDate, disabled } = this.props;
        const icon = this.props.enableIcon ? this.calenderIcon() : null;

        return (
            <div className="flex align-items-center">
                <ReactDatePicker
                    disabled={disabled}
                    dropdownMode="select"
                    minDate={minDate}
                    showTimeSelect={showTimeSelect}
                    dateFormat={this.getDateTimeFormat()}
                    autoFocus={autoFocus}
                    selected={this.state.startDate}
                    onChange={this.handleChange}
                    onChangeRaw={(event) => this.handleChangeRaw(event.target.value)}
                    ref={this.datePickerRef}
                    isClearable={isClearable}
                />
                {icon}
            </div>
        );
    }
}
